import { Body, Container, Head,  Html, Img, Link,  Preview, Section, Text,  } from "@react-email/components";
import * as React from "react";
  
  const EmailTemplate = ({ recipientName, estado, numeroSolicitud, tipo, observaciones,  }) => {
    return (
      <Html>
        <Head />
        <Preview>
          La solicitud {numeroSolicitud} ha sido {estado}
        </Preview>
        <Body style={main}>
          <Container style={container}>
            <Img 
              src="cid:logo@correo" //Aqui le adjunto la imagen por el lado del servidor, alla tengo la imag              
              style={{
                width: "100%",          // Ocupa el ancho disponible del contenedor
                maxWidth: "300px",      // Tamaño máximo para que no crezca demasiado
                height: "auto",         // Ajusta automáticamente la altura para mantener proporciones
                display: "block",       // Evita márgenes automáticos alrededor de la imagen
                margin: "0 auto"        // Centra la imagen horizontalmente
              }}
              alt="CNT"
            />
  
            <Text style={title}>
              <strong></strong>UNICAH - {tipo}{" "}              
            </Text>
  
            <Section style={section}>
              <Text style={text}>
                ¡Hola <strong>{recipientName}</strong>!
              </Text>
              <Text style={text}>La UNICAH te da las {observaciones}</Text>
              {/* <Text style={text}>
                Para revisar su solicitud, de click en el siguiente enlace:
              </Text>
  
              <Button href="eespinoza@unicah.edu" style={button}>
                Revisar
              </Button> */}
            </Section>
            <Text style={links}>
            <Link href="https://www.unicah.edu/educacion/grados/" target="_blank" rel="noopener noreferrer"> UNICAH - Grados</Link>
              <Link style={link}></Link>
            </Text>
  
            <Text style={footer}>
            Tegucigalpa, Honduras Email: admisiones@unicah.edu
            WhatsApp Oficial de la UNICAH: +504 9800-0004
            </Text>
          </Container>
        </Body>
      </Html>
    );
  };
  
  const main = {
    backgroundColor: "#ffffff",
    color: "#24292e",
    fontFamily:
      '-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji"',
  };
  
  const container = {
    maxWidth: "480px",
    margin: "0 auto",
    padding: "20px 0 48px",
  };
  
  const title = {
    fontSize: "24px",
    lineHeight: 1.25,
  };
  
  const section = {
    padding: "24px",
    border: "solid 1px #dedede",
    borderRadius: "5px",
    textAlign: "center",
  };
  
  const text = {
    margin: "0 0 10px 0",
    textAlign: "left",
  };
  
  // const button = {
  //   fontSize: "14px",
  //   backgroundColor: "#66C5D6",
  //   color: "#fff",
  //   lineHeight: 1.5,
  //   borderRadius: "0.5em",
  //   padding: "12px 24px",
  // };
  
  const links = {
    textAlign: "center",
  };
  
  const link = {
    color: "#0366d6",
    fontSize: "12px",
  };
  
  const footer = {
    color: "#6a737d",
    fontSize: "12px",
    textAlign: "center",
    marginTop: "60px",
  };
  
  export default EmailTemplate;
  